import React, { useEffect } from 'react';
import useLanguage from '../../contexts/language/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { useKioskConfiguration } from '../../contexts/kioskConfiguration/KioskConfigurationContext';
import { useDispatch } from 'react-redux';
import { resetTransportationSlice } from '../../store/slices/transportation/transportationSlice';
import { LanguageConfig } from '../../contexts/kioskConfiguration/type';

import './LanguagePage.css'
import { toggleHeaderMenu } from '../../store/slices/app/appSlice';

type LangButtonProps = {
  language: LanguageConfig
  onClick: () => void
}

const LangButton = (props: LangButtonProps): React.ReactElement => {
  const language = useLanguage();

  const onClick = () => {
    language.setLanguage(props.language.code)
    props.onClick()
  }

  return <div className="text-center cursor-pointer" onClick={onClick}>
    <img
      src={`${process.env.APP_DATA_LINK + props.language.flag}`}
      className="w-56 ml-auto mr-auto"
      alt={`Flag for ${props.language.code} country.`}
    />
    <span className="inline-block mt-5 text-2xl" style={{ color: '#434343' }}>{ props.language.label }</span>
  </div>
}

export const LanguagePage = (): React.ReactElement => {
  const navigate = useNavigate()
  const kioskConfigurationContext = useKioskConfiguration()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resetTransportationSlice())
    dispatch(toggleHeaderMenu(true))
  }, []);

  const onClick = () => {
    navigate(kioskConfigurationContext.kioskConfiguration.pageUrlAfterLanguageSelector)
  }

  const languages = kioskConfigurationContext.kioskConfiguration.languages
    .filter((l) => l.visible)
    .sort((a, b) => a.order - b.order)

  return <div className="flex flex-row justify-center items-center language-page">
    {
      languages.map(l => {
        return <LangButton key={l.code} language={l} onClick={onClick} />
      })
    }
  </div>
}
